import { PropTypes } from 'prop-types'
import React, { useState } from 'react'
import { Bounce } from 'react-awesome-reveal'

import { Wrapper, Text } from './styles'

export const NOTIFICATION_POSITIONS = {
    TOP_LEFT: 'top-left',
    TOP_MIDDLE: 'top-middle',
    TOP_RIGHT: 'top-right',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_MIDDLE: 'bottom-middle',
    BOTTOM_RIGHT: 'bottom-right',
}

export const NOTIFICATION_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info',
    WARN: 'warn',
    SNACKBAR: 'snackbar',
}

export const NOTIFICATION_KINDS = {
    SNACKBAR: 'snackbar',
    DEFAULT: 'default',
}

export const COLOR_MAP = {
    [NOTIFICATION_TYPES.SUCCESS]: '#8DD9AD',
    [NOTIFICATION_TYPES.ERROR]: '#FF8B72',
    [NOTIFICATION_TYPES.INFO]: '#85C6EA',
    [NOTIFICATION_TYPES.WARN]: '#FBD74F',
}

const Notification = ({ duration, text, type, position, kind }) => {
    const [isHidden, setIsHidden] = useState(false)

    const isDefault = kind === NOTIFICATION_KINDS.DEFAULT
    /* auto hide */
    isDefault && setTimeout(() => setIsHidden(true), duration)

    return (
        <Wrapper position={position} type={type} hide={isHidden} kind={kind}>
            {isDefault ? (
                <Bounce duration={duration}>{text}</Bounce>
            ) : (
                <Text>{text}</Text>
            )}
        </Wrapper>
    )
}

Notification.propTypes = {
    duration: PropTypes.number,
    type: PropTypes.oneOf(Object.values(NOTIFICATION_TYPES)),
    text: PropTypes.string,
    position: PropTypes.oneOf(Object.values(NOTIFICATION_POSITIONS)),
    kind: PropTypes.oneOf(Object.values(NOTIFICATION_KINDS)),
}

Notification.defaultProps = {
    text: 'oh. sample notification!',
    position: 'top-middle',
    duration: 5000,
    type: 'success',
    kind: 'default',
}

export default Notification
